var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import { colors } from "@wrstudios/theme";
import { Container } from "./styled/tab";
function Tab(_a) {
    var tabList = _a.tabList, parentHandler = _a.parentHandler, activeTab = _a.activeTab, type = _a.type, rightAlign = _a.rightAlign, _b = _a.tabColor, tabColor = _b === void 0 ? colors.gray[600] : _b, _c = _a.activeColor, activeColor = _c === void 0 ? colors.green[600] : _c, props = _a.props;
    var _d = useState(activeTab), selectedTab = _d[0], setSelectedTab = _d[1];
    var tabHandler = function (tab) {
        setSelectedTab(tab.value);
        parentHandler(tab);
    };
    var tabs = tabList.map(function (tab, index) { return (React.createElement("li", { key: index, className: "flex-grow " + type, onClick: function () { return tabHandler(tab); } },
        React.createElement("div", { className: "wrapper  " + (selectedTab === tab.value ? "selected" : "") },
            React.createElement("div", { className: "tab-icon" }, tab.icon),
            React.createElement("div", { className: "title-text" }, tab.text)))); });
    return (React.createElement(Container, __assign({ tabColor: tabColor, activeColor: activeColor, rightAlign: rightAlign }, props), tabs));
}
export default Tab;
